import React from "react";
import ScheduleListContainer from "./ScheduleListContainer";
import AddEditScheduleView from "./AddEditScheduleView";

export default class ScheduleView extends React.Component {
  render() {
    const {
      doctorsDetail,
      handleDailyChange,
      handleStartTimeSelect,
      handleEndTimeSelect,
      schedule,
      dailyChecked,
      saveSchedule,
      cancelSave,
      disableSave,
      handleEdit,
      scheduleId,
      getDetail,
      scheduleType,
      handleChangeFees,
      addUpdateCompRef,
      editingStarted
    } = this.props;

    return (
      <div className="relative">
        <AddEditScheduleView
          handleDailyChange={handleDailyChange}
          handleStartTimeSelect={handleStartTimeSelect}
          handleEndTimeSelect={handleEndTimeSelect}
          schedule={schedule}
          dailyChecked={dailyChecked}
          saveSchedule={saveSchedule}
          cancelSave={cancelSave}
          disableSave={disableSave}
          scheduleId={scheduleId}
          scheduleType={scheduleType}
          handleChangeFees={handleChangeFees}
          addUpdateCompRef={addUpdateCompRef}
          editingStarted={editingStarted}
        />
        <ScheduleListContainer
          doctorsDetail={doctorsDetail}
          // toggleScheduleRemoveModal={toggleScheduleRemoveModal}
          handleEdit={handleEdit}
          getDetail={getDetail}
          scheduleType={scheduleType}
        />
      </div>
    );
  }
}
